import template from './pending-invitations.html';
import controller from './pending-invitations.controller';
import './pending-invitations.scss';

let PendingInvitationsComponent = {
  bindings: {
    invitations: '<',
    profiles: '<'
  },
  template,
  controller
};

export default PendingInvitationsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/pending-invitations/pending-invitations.component.js